// Tenants whose patients get a platform-generated MRN stored in `external_id`.
// For these tenants the External ID is generated server-side and is read-only
// in the UI. Keep this list in sync with the backend
// `PATIENT_MRN_ENABLED_TENANT_SUBDOMAINS` in `decoda/services/patient.py`.
export const PATIENT_MRN_ENABLED_TENANT_SUBDOMAINS = ["novare"] as const;

export function isPatientMrnEnabledTenant(subDomain?: string | null): boolean {
  return PATIENT_MRN_ENABLED_TENANT_SUBDOMAINS.some(
    (enabled) => enabled === subDomain,
  );
}
